<template>
  <div class="login_page main_style">
    <navbar />
    <b-container>
      <b-row
        class="justify-content-center"
        style="height: 100%; margin-top: 10%"
      >
        <b-col class="text-center main-box">
          <b-row>
            <b-col offset-lg="2" lg="8" offset-md="1" md="10">
              <div class="second-box">
                <p style="font-weight: bold; font-size: 24px">
                  การให้ความยินยอม
                </p>
                <p style="color: #828282; font-size: 13px">
                  การให้ความยินยอมในการเก็บรวบรวม ใช้ และเปิดเผย
                </p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col offset-lg="2" lg="8" offset-md="1" md="10">
              <div class="second-box scroll">
                <p class="text-center">
                  <b
                    >นโยบายการคุ้มครองข้อมูลส่วนบุคคลสำหรับการเข้าใช้งานเว็บไซต์</b
                  >
                  <br />
                  <b>ของสำนักงานพัฒนาเศรษฐกิจจากฐานชีวภาพ (องค์การมหาชน)</b>
                  <br />
                  <b
                    >Privacy Policy of Biodiversity-Based Economy Development</b
                  >
                  <br />
                  จัดทำเมื่อวันที่ 30 พฤษภาคม 2565
                </p>
                <p>
                  <template v-for="x in 15">&nbsp;</template
                  >สำนักงานพัฒนาเศรษฐกิจจากฐานชีวภาพ (องค์การมหาชน) หรือ สพภ.
                  ได้จัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ขึ้น
                  เพื่อคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการทุกท่าน (Personal
                  Information) ที่ติดต่อเข้ามายังเว็บไซต์ของ สพภ. ดังนี้
                </p>
                <p><b>การเก็บรวบรวมข้อมูลส่วนบุคคล</b></p>
                <p>
                  1.
                  เพื่อความสะดวกในการให้บริการแก่ผู้ใช้บริการทุกท่านที่เข้ามาใช้บริการเว็บไซต์ของ
                  สพภ. ทางเว็บไซต์จึงได้จัดเก็บรวบรวมข้อมูลส่วนบุคคลของท่านไว้
                  เช่น อีเมล์แอดเดรส (Email Address) ชื่อ (Name)
                  ที่อยู่หรือที่ทำงาน (Home or Work Address) เขตไปรษณีย์ (ZIP
                  Code) หรือหมายเลขโทรศัพท์ (Telephone Number) เป็นต้น
                  <br />
                  2. ในกรณีที่ท่านสมัคร (Sign Up)
                  เพื่อเป็นสมาชิกหรือเพื่อใช้บริการอย่างใดอย่างหนึ่ง
                  เว็บไซต์อาจจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเพิ่มเติม ได้แก่
                  เพศ (Gender) อายุ (Ages) สิ่งที่โปรดปราน/ความชอบ
                  (Preferences/Favorites) ความสนใจ (Interests) และที่อยู่
                  (Address)<br />
                  3. นอกจากนั้น เพื่อสำรวจความนิยมในการใช้บริการ
                  อันจะเป็นประโยชน์ในการนำสถิติไปใช้ในการปรับปรุงคุณภาพในการให้บริการของเว็บไซต์จึงจำเป็นต้องจัดเก็บรวบรวมข้อมูลของท่านบางอย่างเพิ่มเติม
                  ได้แก่ หมายเลขไอพี (IP Address) ชนิดของโปรแกรมค้นดูเว็บ
                  (Browser Type) โดเมนเนม (Domain Name) บันทึกหน้าเว็บ (Web
                  Page) ของเว็บไซต์ที่ผู้ใช้เยี่ยมชม เวลาที่เยี่ยมชมเว็บไซต์
                  (Access Times) และเว็บไซต์ที่ผู้ใช้บริการเข้าถึงก่อนหน้านั้น
                  (Referring Website Addresses)<br />
                  4. สพภ. ขอแนะนำให้ท่านตรวจสอบนโยบายการคุ้มครองข้อมูลส่วนบุคคล
                  (Privacy Policy) ของเว็บไซต์อื่นที่เชื่อมโยงจากเว็บไซต์นี้
                  เพื่อจะได้ทราบและเข้าใจว่าเว็บไซต์ดังกล่าวเก็บรวบรวม
                  ใช้หรือดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่านอย่างไร ทั้งนี้
                  สพภ. ไม่สามารถรับรองข้อความหรือรับรองการดำเนินการใดๆ
                  ตามที่ได้มีการประกาศไว้ในเว็บไซต์ดังกล่าวได้
                  และไม่ขอรับผิดชอบใดๆ
                  หากเว็บไซต์เหล่านั้นไม่ได้ปฏิบัติการหรือดำเนินการใดๆ
                  ตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลที่เว็บไซต์ดังกล่าวได้ประกาศไว้
                </p>
                <p><b>การใช้ข้อมูลส่วนบุคคล</b></p>
                <p>
                  1. สพภ. จะใช้ข้อมูลส่วนบุคคลของท่านเพียงเท่าที่จำเป็น เช่น
                  ชื่อ และ ที่อยู่ เพื่อใช้ในการติดต่อ ให้บริการประชาสัมพันธ์
                  หรือให้ข้อมูลข่าวสารต่างๆ
                  รวมทั้งสำรวจความคิดเห็นของท่านในกิจการหรือกิจกรรมของเว็บไซต์เท่านั้น
                  <br />
                  2. สพภ.
                  ขอรับรองว่าจะไม่นำข้อมูลส่วนบุคคลของท่านที่เว็บไซต์ได้เก็บรวบรวมไว้ไปขายหรือเผยแพร่ให้กับบุคคลภายนอกโดยเด็ดขาด
                  เว้นแต่จะได้รับอนุญาตจากท่านเท่านั้น
                  <br />
                  3. ในกรณีที่ สพภ.
                  ได้ว่าจ้างหน่วยงานอื่นเพื่อให้ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่าน
                  เช่น การจัดส่งพัสดุไปรษณีย์
                  การวิเคราะห์เชิงสถิติในกิจการหรือกิจกรรมของเว็บไซต์ เป็นต้น
                  สพภ. จะกำหนดให้หน่วยงานที่ได้ว่าจ้างให้ดำเนินการดังกล่าว
                  เก็บรักษาความลับ และความปลอดภัยของข้อมูลส่วนบุคคลของท่าน
                  และกำหนดข้อห้ามมิให้มีการนำข้อมูลส่วนบุคคลดังกล่าวไปใช้นอกเหนือจากกิจกรรมหรือกิจการของ
                  สพภ.
                </p>
                <p><b>สิทธิในการควบคุมข้อมูลส่วนบุคคลของท่าน</b></p>
                <p>
                  เพื่อประโยชน์ในการรักษาความเป็นส่วนตัวของท่าน ท่านมีสิทธิตาม
                  พรบ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
                  รวมถึงมีสิทธิเลือกที่จะให้มีการใช้หรือแชร์ข้อมูลส่วนบุคคลของท่าน
                  หรืออาจเลือกที่จะไม่รับข้อมูลหรือสื่อทางการตลาดใดๆ จาก สพภ.
                  ก็ได้ โดยเพียงแต่ท่านกรอกความจำนงดังกล่าวเพื่อแจ้งให้ สพภ.
                  ทราบในหน้าเว็บ
                  <a href="https://www.bedo.or.th/">https://www.bedo.or.th/</a>
                </p>
                <p><b>การรักษาความปลอดภัยสำหรับข้อมูลส่วนบุคคล</b></p>
                <p>
                  เพื่อประโยชน์ในการรักษาความลับและความปลอดภัยสำหรับข้อมูลส่วนบุคคลของท่าน
                  สพภ.
                  จึงได้กำหนดระเบียบภายในหน่วยงานเพื่อกำหนดสิทธิในการเข้าถึงหรือใช้ข้อมูลส่วนบุคคลของท่าน
                  และเพื่อรักษาความลับและความปลอดภัยของข้อมูลบางอย่างที่มีความสำคัญอย่างยิ่ง
                  เว็บไซต์จึงได้จัดให้มีช่องทางการสื่อสารแบบปลอดภัยสำหรับข้อมูลดังกล่าวด้วยการเข้ารหัสลับข้อมูลดังกล่าว
                  เช่น จัดให้มีการใช้ Secure Socket Layer (SSL) Protocol เป็นต้น
                </p>
                <p><b>การใช้คุกกี้ (Cookies)</b></p>
                <p>
                  “คุกกี้” คือ
                  ไฟล์ข้อมูลขนาดเล็กที่จะถูกส่งไปเก็บไว้ยังโปรแกรมค้นดูเว็บ (Web
                  Browser) ของผู้ใช้บริการ
                  เพื่อทำการเก็บข้อมูลที่ผู้ใช้บริการเข้าเยี่ยมชมไว้
                  เมื่อผู้ใช้บริการมีการเข้าไปเยี่ยมชมเว็บไซต์ต่างๆอีกครั้งในภายหลัง
                  โปรแกรมค้นดูเว็บจะจดจำได้ว่าผู้ใช้บริการเคยเข้าเยี่ยมชมแล้ว
                  จนกว่าผู้ใช้บริการจะออกจากโปรแกรมค้นดูเว็บไซต์
                  หรือจนกว่าผู้ใช้บริการจะทำการลบ “คุกกี้” นั้นเสีย
                  หรือไม่อนุญาตให้ “คุกกี้” นั้น ทำงานอีกต่อไป หากท่านเลือกใช้
                  “คุกกี้” แล้ว
                  ท่านจะได้รับความสะดวกสบายในการท่องเว็บไซต์มากขึ้น เพราะ
                  “คุกกี้” จะช่วยจดจำเว็บไซต์ที่ท่านแวะหรือเยี่ยมชม ทั้งนี้ สพภ.
                  จะนำข้อมูลที่ “คุกกี้” ได้บันทึกหรือเก็บรวบรวมไว้
                  ไปใช้ในการวิเคราะห์เชิงสถิติ
                  หรือในกิจกรรมอื่นของเว็บไซต์เพื่อปรับปรุงคุณภาพการให้บริการของเว็บไซต์ต่อไป
                </p>
                <p><b>การปรับปรุงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</b></p>
                <p>
                  สพภ. อาจทำการปรับปรุงหรือแก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคล
                  ทั้งนี้ เพื่อความเหมาะสมและมีประสิทธิภาพในการให้บริการ ดังนั้น
                  สพภ.
                  จึงขอแนะนำให้ผู้ใช้บริการอ่านนโยบายการคุ้มครองข้อมูลส่วนบุคคลทุกครั้งที่เยี่ยมชม
                  หรือมีการใช้บริการจากเว็บไซต์ของ สพภ.
                </p>
                <p>
                  <b
                    >การปฏิบัติตามนโยบายคุ้มครองข้อมูลส่วนบุคคลและการติดต่อกับ
                    สพภ.</b
                  >
                </p>
                <p>
                  ในกรณีที่ท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใดๆ
                  เกี่ยวกับนโยบายการคุ้มครองข้อมูลส่วนบุคคล
                  หรือการปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ สพภ.
                  ยินดีที่จะตอบข้อสงสัย รับฟังข้อเสนอแนะ และ คำติชมทั้งหลาย
                  อันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการของเว็บไซต์ต่อไป
                  โดยท่านสามารถติดต่อ สพภ. ตามที่อยู่ที่ปรากฏข้างล่างนี้
                </p>
                <p>
                  สำนักงานพัฒนาเศรษฐกิจจากฐานชีวภาพ (องค์การมหาชน) <br />
                  ศูนย์ราชการเฉลิมพระเกียรติ ๘๐ พรรษา ๕ ธันวาคม ๒๕๕๐ <br />
                  อาคารรัฐประศาสนภักดี ชั้น 9 เลขที่ 120 หมู่ที่ 3 ถนนแจ้งวัฒนะ
                  แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210
                  <br />
                  อีเมล saraban@bedo.or.th <br />
                  เว็บไซต์ <a href="www.bedo.or.th">www.bedo.or.th</a> <br />
                  หมายเลขโทรศัพท์ (66) 2141 7800
                </p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col offset-lg="2" lg="8" offset-md="1" md="10">
              <div class="second-box">
                <b-input-group>
                  <p
                    class="mb-3 mt-1 pt-4 w-75"
                    style="color: rgba(219, 127, 80, 1); font-size: 14px"
                  >
                    กดยินยอมเพื่อไม่พลาดข่าวสารจากเรา
                  </p>
                  <b-input-group-append class="pt-3">
                    <button
                      @click="login"
                      style="
                        border-radius: 20px;
                        background: rgba(219, 127, 80, 1);
                        color: white;
                        border: 0;
                        width: 120px;
                        height: 40px;
                      "
                    >
                      ยอมรับ
                    </button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <!--    <p class="mt-3" style="color: rgba(219, 127, 80, 1); font-size: 14px">-->
    <!--      กดยินยอมเพื่อไม่พลาดข่าวสารจากเรา-->
    <!--      <button-->
    <!--          @click="login"-->
    <!--          class="float-right"-->
    <!--          style="-->
    <!--                border-radius: 20px;-->
    <!--                background: rgba(219, 127, 80, 1);-->
    <!--                width: 25%;-->
    <!--                color: white;-->
    <!--                border: 0;-->
    <!--                padding: 10px 20px 10px 20px;-->
    <!--              "-->
    <!--      >-->
    <!--        ยอมรับ-->
    <!--      </button>-->
    <!--    </p>-->
  </div>
</template>

<script>
import Navbar from "@/components/navbar";
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "PDPA",
  components: { Navbar },
  computed: {
    ...mapState({
      data: (state) => state.AuthModule.userLogin,
    }),
  },
  methods: {
    login() {
      let path = "/";
      if (this.$route.path !== path) this.$router.push(path);
      // let data = {
      //   email: this.data.email ? this.data.email : null,
      //   password: this.data.password ? this.data.password : null,
      // };
      // this.$store.dispatch("AuthModule/onLogin", data).then((res) => {
      //   console.log(res.code);
      //   if (res && res.code == 200) {
      //     Swal.hideLoading();
      //     let path = "/pdpa";
      //     if (this.$route.path !== path) this.$router.push(path);
      //   } else {
      //     Swal.fire({
      //       title: "เข้าสู่ระบบผิดพลาด",
      //       icon: "error",
      //     });
      //     let path = "/login";
      //     if (this.$route.path !== path) {
      //       this.$router.push(path);
      //     } else {
      //       window.location.reload();
      //     }
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.login_page {
  background-image: url("../assets/images/background/bg_login.svg");
  /* Full height */
  height: auto;
  width: 100%;
  /* Center and scale the image nicely */
  //background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.main-box {
  //padding-left: 33%;
  //padding-right: 33%;
}
.second-box {
  background: #ffffff;
  opacity: 0.95;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  text-align: left;
  padding: 2%;
  width: 100%;
}
p,
li,
span {
  text-align: left;
  margin-bottom: 0;
}
li {
  font-size: 14px;
}
hr {
  border: 1px solid #db7f50;
  margin-left: -5%;
  margin-right: -5%;
}
.scroll {
  max-height: 450px;
  overflow-y: auto;
}
</style>
